import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {Observable} from 'rxjs';
import {constants} from '../constant/constants';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  constructor(private http: HttpClient) {
  }

  // user
  login(request): Observable<any> {
    return this.http.post<any>(constants.main_url + "/user/login", request);
  }

  getallusers(): Observable<any> {
    return this.http.get<any>(constants.main_url + "/user/search-all");
  }

  getallcategory(): Observable<any> {
    return this.http.get<any>(constants.main_url + "/util/package-category/getActive");
  }

  newUser(request): Observable<any> {
    return this.http.post<any>(constants.main_url + "/user/createOrEdit", request)
  }

  newCategory(request): Observable<any> {
    return this.http.post<any>(constants.main_url + "/util/packages-category/createOrEdit", request)
  }

  chnagePassword(request): Observable<any> {
    return this.http.post<any>(constants.main_url + "/user/change-pwd", request)
  }

  deleteUser(id): Observable<any> {
    return this.http.get<any>(constants.main_url + "/user/disable/" + id);
  }

  activeUser(id): Observable<any> {
    return this.http.get<any>(constants.main_url + "/user/active/" + id);
  }


  // packages
  normalpackagesGetall(): Observable<any> {
    return this.http.get<any>(constants.main_url + "/packages/get/normal?type=sdfds");
  }

  propackagesGetall(): Observable<any> {
    return this.http.get<any>(constants.main_url + "/packages/get/normal?type=sdfds");
  }

  packageSearch(req,size,page): Observable<any> {
    return this.http.post<any>(constants.main_url + "/packages/search?size=" + size + "&page=" + page, req);
  }

  createPackage(req): Observable<any> {
    return this.http.post<any>(constants.main_url + "/packages/createOrEdit", req);
  }

  createItenary(req): Observable<any> {
    return this.http.post<any>(constants.main_url + "/packages/createOrEdit/itenary", req);
  }

  deletePackage(id): Observable<any> {
    return this.http.put<any>(constants.main_url + "/packages/disable/" + id, '');
  }

  uploadPackageImg(file, id): Observable<any> {
    const formData: FormData = new FormData();
    formData.append('imageFile ', file);
    return this.http.post<Array<JSON>>(constants.main_url + '/packages/upload/' + id, formData, {});
  }
  uploadItenaryImg(file, id): Observable<any> {
    const formData: FormData = new FormData();
    formData.append('imageFile ', file);
    console.log(file.name);
    return this.http.post<Array<JSON>>(constants.main_url + '/packages/upload/itenary/' + id, formData, {});
  }


  // Reviews
  getAllActiveReviews(size,page): Observable<any> {
    return this.http.get<any>(constants.main_url + "/client-reviews/getAll-admin?page="+page+"&size="+size);
  }

  getAllPendingReviews(): Observable<any> {
    return this.http.get<any>(constants.main_url + "/client-reviews/getAll/pending");
  }

  approve(id): Observable<any> {
    return this.http.put<any>(constants.main_url + "/client-reviews/approve/" + id, '');
  }

  regect(id): Observable<any> {
    return this.http.put<any>(constants.main_url + "/client-reviews/reject/" + id, '');
  }

  // catagort
  getAllCategory(): Observable<any> {
    return this.http.get<any>(constants.main_url + "/util/package-category/getActive");
  }

  getAllType(): Observable<any> {
    return this.http.get<any>(constants.main_url + "/util/travel-types");
  }

  // booking
  bookingSave(): Observable<any> {
    return this.http.post<any>(constants.main_url + "/booking/save", '');
  }
  arrangelist(id,req): Observable<any> {
    return this.http.post<any>(constants.main_url + "/packages/arrange/itenary/"+id, req);
  }
  ticketbookingSave(): Observable<any> {
    return this.http.post<any>(constants.main_url + "/booking/ticket/save", '');
  }
  bookinggetAll(size,page,req): Observable<any> {
    return this.http.post<any>(constants.main_url + "/booking/tours/search?page="+page+"&size="+size,req);
  }
  ticketbookinggetAll(size,page,req): Observable<any> {
    return this.http.post<any>(constants.main_url + "/booking/tickets/search?page="+page+"&size="+size,req);
  }
  bookingsearch(size,page,req): Observable<any> {
    return this.http.post<any>(constants.main_url + "/booking/tours/search?page="+page+"&size=1"+size,req);
  }
  bookinggetAllActive(): Observable<any> {
    return this.http.get<any>(constants.main_url + "/booking/getAll-active");
  }

  deleteItenary(id): Observable<any> {
    return this.http.get<any>(constants.main_url + "/packages/delete/itenary/"+id);
  }

  confiremBooking(id): Observable<any> {
    return this.http.get<any>(constants.main_url + "/booking/confirm/" + id);
  }
  ticketconfiremBooking(id): Observable<any> {
    return this.http.get<any>(constants.main_url + "/booking/ticket/confirm/" + id);
  }

  cancelBooking(id,reson): Observable<any> {
    return this.http.get<any>(constants.main_url + "/booking/cancel/" + id +"?reason="+reson);
  }
  ticketcancelBooking(id): Observable<any> {
    return this.http.get<any>(constants.main_url + "/booking/cancel/tikcket/" + id +"?reason=none");
  }

  // GALARY
  getAllGalary(): Observable<any> {
    return this.http.get<any>(constants.main_url + "/gallery/get/all");
  }

  getAllGalaryImage(id): Observable<any> {
    return this.http.get<any>(constants.main_url + "/gallery/get/image/" + id);
  }

  galaryImageDlt(id): Observable<any> {
    return this.http.delete<any>(constants.main_url + "/gallery/delete/image/" + id);
  }


  uploadAllGalaryImage(fileToUpload): Observable<any> {
    const formData: FormData = new FormData();
    formData.append('file', fileToUpload);
    return this.http.post<Array<JSON>>(constants.main_url + '/gallery/upload', formData, {});
  }

  deleteGalaryImg(id): Observable<any> {
    return this.http.delete<any>(constants.main_url + "/gallery/delete/image/" + id);
  }

  //Transport
  getAllTransport(): Observable<any> {
    return this.http.get<any>(constants.main_url + "/transport/getAll");
  }

  createTransport(req): Observable<any> {
    return this.http.post<any>(constants.main_url + "/transport/saveOrUpdate", req);
  }

  deleteTransport(id): Observable<any> {
    return this.http.delete<any>(constants.main_url + "/transport/delete/" + id);
  }

  transportImgUpload(file, id): Observable<any> {
    const formData: FormData = new FormData();
    formData.append('imageFile ', file);
    return this.http.post<Array<JSON>>(constants.main_url + '/transport/upload/' + id, formData, {});
  }

  getTransportImg(id): Observable<any> {
    return this.http.get<any>(constants.main_url + "/transport/get/image/" + id);
  }

  // Notice
  getAllNote(): Observable<any> {
    return this.http.get<any>(constants.main_url + "/getAll");
  }

  createNote(req): Observable<any> {
    return this.http.post<any>(constants.main_url + "/saveOrEdit", req);
  }


  deleteNote(id): Observable<any> {
    return this.http.delete<any>(constants.main_url + "/delete/"+id);
  }


  getallDestinations(): Observable<any> {
    return this.http.get<any>(constants.main_url + "/destination/getAll-active");
  }

  searchDestinations(req,size,page): Observable<any> {
    return this.http.post<any>(constants.main_url + "/destination/search/destination?name="+req+"&page=0&size=10", {});
  }

  searchUni(req,size,page): Observable<any> {
    return this.http.post<any>(constants.main_url + "/destination/search/univercities?name="+req+"&page=0&size=10", {});
  }

  searchCorse(req,size,page): Observable<any> {
    return this.http.post<any>(constants.main_url + "/destination/search/courses?name="+req+"&page=0&size=10", {});
  }

  createDestinations(req): Observable<any> {
    return this.http.post<any>(constants.main_url + "/destination/create", req);
  }

  delteDestinations(id): Observable<any> {
    return this.http.delete<any>(constants.main_url + "/destination/course/delete/"+id);
  }

  destinationImgUpload(file, id): Observable<any> {
    const formData: FormData = new FormData();
    formData.append('imageFile ', file);
    return this.http.post<Array<JSON>>(constants.main_url + '/destination/uploadImage/' + id, formData, {});
  }

  createCorse(req, id): Observable<any> {
    return this.http.post<any>(constants.main_url + "/destination/create-courses/" + id, req);
  }

  delteCorse(id): Observable<any> {
    return this.http.delete<any>(constants.main_url + "/destination/course/delete/"+ id);
  }

  getAllCorse(): Observable<any> {
    return this.http.get<any>(constants.main_url + "/destination/getAll-active/courses");
  }

  getAllUni(): Observable<any> {
    return this.http.get<any>(constants.main_url + "/destination/univercities/getAllActive}");
  }

  deleteUni(id): Observable<any> {
    return this.http.delete<any>(constants.main_url + "/destination/uni/delete/"+id);
  }


  createUni(req, id): Observable<any> {
    return this.http.post<any>(constants.main_url + "/destination/create-univercities/" + id, req);
  }

  uniImgUpload(file, id): Observable<any> {
    const formData: FormData = new FormData();
    formData.append('imageFile ', file);
    return this.http.post<Array<JSON>>(constants.main_url + '/destination/uni/uploadImage/' + id, formData, {});
  }

  // TICKETING
  getAllAirports(): Observable<any> {
    return this.http.get<any>(constants.main_url + "/util/getAirports");
  }

  searchTicket(req,size,page): Observable<any> {
    return this.http.post<any>(constants.main_url + "/airticket/search?page="+page+"&size="+size,req);
  }
  createTicket(req): Observable<any> {
    return this.http.post<any>(constants.main_url +"/airticket/create",req);
  }
  deleteTicket(id): Observable<any> {
    return this.http.post<any>(constants.main_url +"/airticket/delete/"+id,{});
  }

  uploadTicketImg(file, id): Observable<any> {
    const formData: FormData = new FormData();
    formData.append('imageFile ', file);
    return this.http.post<Array<JSON>>(constants.main_url + '/airticket/upload/' + id, formData, {});
  }

}

